export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./training.vue?vue&type=template&id=ecb71d82&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/training.vue?vue&type=template&id=ecb71d82&
// module id = 1378
// module chunks = 0